// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDataItemByIdRequestModel from '../../model/get-data-item-by-id-request-model';
import GetDataItemByIdRequestDTO from '../dto/get-data-item-by-id-request-dto';
import dtoSchema from '../schemas/get-data-item-by-id-request-schema';

export default abstract class GetDataItemByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDataItemByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetDataItemByIdRequestDTO>): GetDataItemByIdRequestModel;
  static toModel(dto: DeepPartial<GetDataItemByIdRequestDTO> | undefined | null): GetDataItemByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDataItemByIdRequestDTO> | undefined | null): GetDataItemByIdRequestModel | undefined {
    return dto ? new GetDataItemByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDataItemByIdRequestModel> | GetDataItemByIdRequestModel): GetDataItemByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetDataItemByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDataItemByIdRequestModel, can not map to GetDataItemByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
